
export function handleMoreText() {

    const observer = new MutationObserver(() => {

        const condicionesPequeña = document.getElementsByClassName("condiciones_pequeña");
        const condicionesGrande = document.getElementsByClassName("condiciones_grande");
        const leerMas = document.getElementsByClassName("leer_mas");
        const leerMenos = document.getElementsByClassName("leer_menos");

        const publicidadPequeña = document.getElementsByClassName("publicidad_pequeña");
        const publicidadGrande = document.getElementsByClassName("publicidad_grande");
        const leerMasPublicidad = document.getElementsByClassName("leer_mas_publicidad");
        const leerMenosPublicidad = document.getElementsByClassName("leer_menos_publicidad");

        if (leerMas.length > 0) {

            for (let i = 0; i < leerMas.length; ++i) {

                leerMas[i].addEventListener('click', () => {
                    condicionesPequeña[i].style.display = 'none';
                    condicionesGrande[i].style.display = 'block'
                });

                leerMenos[i].addEventListener('click', () => {
                    condicionesPequeña[i].style.display = 'block';
                    condicionesGrande[i].style.display = 'none'
                });

            }

        }

        if (leerMasPublicidad.length > 0) {

            for (let i = 0; i < leerMasPublicidad.length; ++i) {

                leerMasPublicidad[i].addEventListener('click', () => {
                    publicidadPequeña[i].style.display = 'none';
                    publicidadGrande[i].style.display = 'block'
                });

                leerMenosPublicidad[i].addEventListener('click', () => {
                    publicidadPequeña[i].style.display = 'block';
                    publicidadGrande[i].style.display = 'none'
                });
            }
        }

        if (leerMas.length > 0 || leerMasPublicidad.length > 0) {

            // Detener la observación después de encontrar el elemento
            setTimeout(() => {
                observer.disconnect();
            }, 3000);
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

}
